import type { Ref } from 'vue';
import { computed } from 'vue';

import type { ITranslationsKeyMap } from '@modules/i18n/types';

export function getTranslationKeys(): Ref<ITranslationsKeyMap> {
  return computed(() => ({
    admin: {
      settings: {
        general_settings: {
          tabs: {
            bookkeeping: {
              tab_name: 'TAB_NAME',
              form: {
                limit: 'FORM_LIMIT',
                date: 'FORM_DATE',
              },
              history_changes: {
                edit: {
                  header: 'HISTORY_HEADER',
                  save: 'HISTORY_SAVE',
                  back: 'HISTORY_BACK',
                  form: {
                    limit: 'HISTORY_FORM_LIMIT',
                    date: 'HISTORY_FORM_DATE',
                  },
                },
              },
            },
          },
        },
      },
    },
  }));
}
